import React from 'react';
import styles from './index.module.scss'
interface ColorItemProps{
    isActive: boolean
    currentColor: string
    getColor: (color: string) => void
}

export default function ColorItemPicker({currentColor, isActive, getColor}: ColorItemProps){
    return (
        <div
            className={styles.colorItem}
            style={{borderColor: isActive ? currentColor : "transparent"}}
            onClick={() => getColor(currentColor)}
        >
            <div className={styles.colorItem__item} style={{background: currentColor}}>
                {isActive && (
                    <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.13477 0.25C8.23931 0.250026 8.34289 0.27048 8.43945 0.310547C8.53594 0.350584 8.62345 0.40948 8.69727 0.483398L8.75 0.541016C8.7996 0.601333 8.84006 0.668834 8.87012 0.741211C8.91016 0.83772 8.93062 0.941412 8.93066 1.0459C8.93066 1.15036 8.9101 1.25408 8.87012 1.35059C8.84003 1.4231 8.7997 1.49135 8.75 1.55176L8.69727 1.60938L3.79004 6.5166C3.71626 6.59053 3.62868 6.64939 3.53223 6.68945C3.43575 6.72949 3.33199 6.74994 3.22754 6.75C3.12293 6.75 3.01849 6.72955 2.92188 6.68945C2.84952 6.6594 2.78198 6.61892 2.72168 6.56934L2.66406 6.5166L0.483398 4.33594C0.334126 4.18666 0.25 3.98356 0.25 3.77246C0.250047 3.56142 0.334168 3.35919 0.483398 3.20996C0.63265 3.06074 0.834845 2.97658 1.0459 2.97656C1.25694 2.97656 1.45914 3.06077 1.6084 3.20996L3.22656 4.82812L7.57129 0.483398C7.64516 0.409341 7.73346 0.350637 7.83008 0.310547C7.9266 0.270544 8.03028 0.25 8.13477 0.25Z" fill="white" stroke="white" strokeWidth="0.5"/>
                    </svg>
                )}
            </div>
        </div>
    )
}
